import { HTMLAttributes, memo } from "react";

import { ReactComponent as BoxGrayIconLg } from "./icons/BoxGrayLg.svg";
import { ReactComponent as BoxGrayIconMd } from "./icons/BoxGrayMd.svg";
import { ReactComponent as BoxGrayIconSm } from "./icons/BoxGraySm.svg";
import { ReactComponent as BoxPrimaryIconLg } from "./icons/BoxPrimaryLg.svg";
import { ReactComponent as BoxPrimaryIconMd } from "./icons/BoxPrimaryMd.svg";
import { ReactComponent as BoxPrimaryIconSm } from "./icons/BoxPrimarySm.svg";
import { ReactComponent as CloudGrayIconLg } from "./icons/CloudGrayLg.svg";
import { ReactComponent as CloudGrayIconMd } from "./icons/CloudGrayMd.svg";
import { ReactComponent as CloudGrayIconSm } from "./icons/CloudGraySm.svg";
import { ReactComponent as CloudPrimaryIconLg } from "./icons/CloudPrimaryLg.svg";
import { ReactComponent as CloudPrimaryIconMd } from "./icons/CloudPrimaryMd.svg";
import { ReactComponent as CloudPrimaryIconSm } from "./icons/CloudPrimarySm.svg";
import { ReactComponent as CreditCardGrayIconLg } from "./icons/CreditCardGrayLg.svg";
import { ReactComponent as CreditCardGrayIconMd } from "./icons/CreditCardGrayMd.svg";
import { ReactComponent as CreditCardGrayIconSm } from "./icons/CreditCardGraySm.svg";
import { ReactComponent as CreditCardPrimaryIconLg } from "./icons/CreditCardPrimaryLg.svg";
import { ReactComponent as CreditCardPrimaryIconMd } from "./icons/CreditCardPrimaryMd.svg";
import { ReactComponent as CreditCardPrimaryIconSm } from "./icons/CreditCardPrimarySm.svg";
import { ReactComponent as DocumentsGrayIconLg } from "./icons/DocumentsGrayLg.svg";
import { ReactComponent as DocumentsGrayIconMd } from "./icons/DocumentsGrayMd.svg";
import { ReactComponent as DocumentsGrayIconSm } from "./icons/DocumentsGraySm.svg";
import { ReactComponent as DocumentsPrimaryIconLg } from "./icons/DocumentsPrimaryLg.svg";
import { ReactComponent as DocumentsPrimaryIconMd } from "./icons/DocumentsPrimaryMd.svg";
import { ReactComponent as DocumentsPrimaryIconSm } from "./icons/DocumentsPrimarySm.svg";

import styles from "./styles.module.scss";

export type iconType = "CloudPrimaryLg" | "CloudGrayLg" | "BoxPrimaryLg" | "BoxGrayLg" | "DocumentsPrimaryLg" | "DocumentsGrayLg" | "CreditCardPrimaryLg" | "CreditCardGrayLg" | "CloudPrimaryMd" | "CloudGrayMd" | "BoxPrimaryMd" | "BoxGrayMd" | "DocumentsPrimaryMd" | "DocumentsGrayMd" | "CreditCardPrimaryMd" | "CreditCardGrayMd" | "CloudPrimarySm" | "CloudGraySm" | "BoxPrimarySm" | "BoxGraySm" | "DocumentsPrimarySm" | "DocumentsGraySm" | "CreditCardPrimarySm" | "CreditCardGraySm"

export type EmptyStateIllustrationIconProps = HTMLAttributes<HTMLDivElement> & {
  iconType?: iconType
}

export const EmptyStateIllustrationIcon = memo<EmptyStateIllustrationIconProps>(({ iconType, className, ...props }) => {

  //todo check illustration colors
  const getIcon = () => {
    switch (iconType) {
      case "CloudPrimaryLg": return <CloudPrimaryIconLg />
      case "CloudGrayLg": return <CloudGrayIconLg />
      case "BoxPrimaryLg": return <BoxPrimaryIconLg />
      case "BoxGrayLg": return <BoxGrayIconLg />
      case "DocumentsPrimaryLg": return <DocumentsPrimaryIconLg />
      case "DocumentsGrayLg": return <DocumentsGrayIconLg />
      case "CreditCardPrimaryLg": return <CreditCardPrimaryIconLg />
      case "CreditCardGrayLg": return <CreditCardGrayIconLg />
      case "CloudPrimaryMd": return <CloudPrimaryIconMd />
      case "CloudGrayMd": return <CloudGrayIconMd />
      case "BoxPrimaryMd": return <BoxPrimaryIconMd />
      case "BoxGrayMd": return <BoxGrayIconMd />
      case "DocumentsPrimaryMd": return <DocumentsPrimaryIconMd />
      case "DocumentsGrayMd": return <DocumentsGrayIconMd />
      case "CreditCardPrimaryMd": return <CreditCardPrimaryIconMd />
      case "CreditCardGrayMd": return <CreditCardGrayIconMd />
      case "CloudPrimarySm": return <CloudPrimaryIconSm />
      case "CloudGraySm": return <CloudGrayIconSm />
      case "BoxPrimarySm": return <BoxPrimaryIconSm />
      case "BoxGraySm": return <BoxGrayIconSm />
      case "DocumentsPrimarySm": return <DocumentsPrimaryIconSm />
      case "DocumentsGraySm": return <DocumentsGrayIconSm />
      case "CreditCardPrimarySm": return <CreditCardPrimaryIconSm />
      case "CreditCardGraySm": return <CreditCardGrayIconSm />
      default: return <CloudPrimaryIconLg />
    }
  }

  return (
    <div
      {...props}
      className={styles.root}
    >
      {getIcon()}
    </div>
  );
});